export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export const SORT_KEYS = {
  ALPHABET: 'alphabet',
  DATE: 'date'
}